import axios from "axios";

export function apiLoginColidee(formData) {
  return axios
    .post(process.env.REACT_APP_URL_COLIDEE + "apiVerifAndDeliverTokenFromEasyGouv", formData)
    .then(function (response) {
      return response;
    })
    .catch(function (error) {
      return error.response;
    });
}

export function apiVerifTokenColidee(token) {
  return axios
    .get(process.env.REACT_APP_URL_COLIDEE + "apiVerifAndAutoLoginTokenFromEasyGouv?token=" + token)
    .then(function (response) {
      return response;
    })
    .catch(function (error) {
      return error.response;
    });
}

export function apiVerifTokenColideeFlashCode(token) {
  return axios
    .get(
      process.env.REACT_APP_URL_COLIDEE +
        "apiVerifAndAutoLoginTokenFromEasyGouv?flashCode=1&token=" +
        token
    )
    .then(function (response) {
      return response;
    })
    .catch(function (error) {
      return error.response;
    });
}

export function apiRegisterColidee(formData) {
  return axios
    .post(process.env.REACT_APP_URL_COLIDEE + "apiRegisterColideeFromEasyGouv", formData)
    .then(function (response) {
      return response;
    })
    .catch(function (error) {
      return error.response;
    });
}

export function apiValideActivationColidee(codeActivation) {
  return axios
    .get(
      process.env.REACT_APP_URL_COLIDEE +
        "apiActivateFromEasyGouv?a=" +
        codeActivation +
        "&activateFromAppli=1"
    )
    .then(function (response) {
      return response;
    })
    .catch(function (error) {
      return error.response;
    });
}
